module.exports = __webpack_public_path__ + "static/media/double-upOrange.cc667f63.svg";